import SurveyStepSimulationContainer from "./SurveyStepSimulationContainer"
export default SurveyStepSimulationContainer


// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/index.js